/**
 * PLACEHOLDER: Decorative geometric shapes inspired by FiveVai website
 * Replace these with your actual decorative SVG elements
 */

// Large teal circle
export function TealCircle({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* REPLACE: Large teal circle from website */}
      <circle
        cx="200"
        cy="200"
        r="200"
        fill="var(--brand-primary)"
        opacity="0.65"
      />
    </svg>
  );
}

// Large yellow/gold circle
export function YellowCircle({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* REPLACE: Large yellow circle from website */}
      <circle
        cx="200"
        cy="200"
        r="200"
        fill="var(--brand-accent)"
        opacity="0.75"
      />
    </svg>
  );
}

// Orange diagonal shape (equilateral triangle pointing right)
export function OrangeDiagonal({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Equilateral triangle with point facing right toward center */}
      <path
        d="M0 10 L0 290 L150 150 Z"
        fill="var(--brand-secondary)"
        opacity="0.75"
      />
    </svg>
  );
}

// Dotted pattern decoration
export function DottedPattern({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* REPLACE: Dotted pattern from website */}
      {Array.from({ length: 10 }).map((_, row) =>
        Array.from({ length: 10 }).map((_, col) => (
          <circle
            key={`${row}-${col}`}
            cx={col * 10 + 5}
            cy={row * 10 + 5}
            r="1.5"
            fill="currentColor"
            opacity="0.4"
          />
        )),
      )}
    </svg>
  );
}

// Small decorative dots (scattered)
export function DecorativeDots({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* REPLACE: Decorative dots pattern from website */}
      <circle cx="20" cy="20" r="4" fill="currentColor" />
      <circle cx="50" cy="15" r="3" fill="currentColor" />
      <circle cx="180" cy="30" r="5" fill="currentColor" />
      <circle cx="150" cy="50" r="3" fill="currentColor" />
      <circle cx="170" cy="70" r="4" fill="currentColor" />
      <circle cx="30" cy="180" r="5" fill="currentColor" />
      <circle cx="60" cy="170" r="3" fill="currentColor" />
    </svg>
  );
}

// Asterisk/star decoration
export function AsteriskDecoration({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* REPLACE: Star/asterisk decoration from website */}
      <path
        d="M12 2L12 22M2 12L22 12M5 5L19 19M19 5L5 19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
